wbApp.filter('courseFullName', ['courseSvc', function (courseSvc) {
    return function (input) {
        if (input) {
            return courseSvc.getCourseFullName(input);
        }

        return input;
    };
}]);